<script setup lang="ts">
import { computed } from "vue";
import { Temporal } from "@js-temporal/polyfill";

// Elapsed time in milliseconds — either a duration (encounter length) or a
// timestamp into the pull. Rendered consistently as M:SS everywhere.
const props = defineProps<{ timestamp: number }>();

const balanced = computed(() =>
  Temporal.Duration.from({ milliseconds: Math.max(0, Math.round(props.timestamp)) })
    .round({ largestUnit: "minute", smallestUnit: "second" }),
);

// ISO 8601 duration (e.g. "PT2M5S") for the <time> machine-readable value.
const iso = computed(() => balanced.value.toString());

// Human clock, e.g. "2:05".
const clock = computed(
  () => `${balanced.value.minutes}:${String(balanced.value.seconds).padStart(2, "0")}`,
);
</script>

<template>
  <time :datetime="iso">{{ clock }}</time>
</template>
